import React from 'react';

import { MosPosOrderConfirmPage } from '@/pages/externals/mos-pos-resend/detail/MosPosOrderConfirmPage';

/** SCR002 再送信確認 */
const MosPosResendConfirmPage: React.VFC = () => (
  <MosPosOrderConfirmPage mode="resend" />
);

export default MosPosResendConfirmPage;
